import React from 'react';
import {connect} from 'react-redux'
import {Field} from 'redux-form/immutable';
import {reduxForm} from 'redux-form/immutable';
import {Modal, Button, Form} from 'antd';
import {TextField, SelectField} from 'redux-form-antd'
import {
    openModal,
    chageModal,
    closeModal
} from "../../../actions";
import {
    editApplicationForAdmission,
    updateApplicationForAdmission
} from "../../../actions/ApplicationForAdmissionAction";
import {
    required, nullValue1,
} from "../validDesc";

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 5},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 19},
    },
};
let BrothersMembersModal = props => {
    const {modalIsOpen, closeModal} = props;
    const {handleSubmit} = props;

    const school_class_select = [
        {
            label: '-- 請選擇 --',
            value: '-1'
        },
        {
            value: '101',
            label: '一年一班'
        },
        {
            value: '102',
            label: '一年二班'
        },
        {
            value: '103',
            label: '一年三班'
        },
        {
            value: '104',
            label: '一年四班'
        },
        {
            value: '201',
            label: '二年一班'
        },
        {
            value: '202',
            label: '二年二班'
        },
        {
            value: '203',
            label: '二年三班'
        },
        {
            value: '204',
            label: '二年四班'
        }
        ,
        {
            value: '301',
            label: '三年一班'
        },
        {
            value: '302',
            label: '三年二班'
        },
        {
            value: '303',
            label: '三年三班'
        },
        {
            value: '304',
            label: '三年四班'
        },
        {
            value: '401',
            label: '四年一班'
        },
        {
            value: '402',
            label: '四年二班'
        },
        {
            value: '403',
            label: '四年三班'
        },
        {
            value: '404',
            label: '四年四班'
        },
        {
            value: '501',
            label: '五年一班'
        },
        {
            value: '502',
            label: '五年二班'
        },
        {
            value: '503',
            label: '五年三班'
        },
        {
            value: '504',
            label: '五年四班'
        },
        {
            value: '601',
            label: '六年一班'
        },
        {
            value: '602',
            label: '六年二班'
        },
        {
            value: '603',
            label: '六年三班'
        },
        {
            value: '604',
            label: '六年四班'
        }
    ]
    return (
        <Modal
            title={'在校生弟妹'}
            visible={modalIsOpen}
            onCancel={() => closeModal('brothers_members_modal')}
           footer={null}
        >
            <Form onSubmit={handleSubmit} noValidate>
                <p style={{color: 'red', fontWeight: 'bold'}}>現在就讀班級與姓名</p>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label="班級選擇"
                       options={school_class_select} name="stud_brothers_class" type="label"></Field>
                <Field {...formItemLayout} validate={[required]} component={TextField} label="姓名"
                       name="stud_brothers_name" type="label"></Field>
                <Button htmlType="submit" type={'primary'} size={'large'}
                        style={{width: '100%', marginTop: '10px'}}>
                    送出
                </Button>
            </Form>

        </Modal>
    )
}


BrothersMembersModal = reduxForm({
    form: 'BrothersMembersModalForm', // a unique identifier for this form
    enableReinitialize: true,
})(BrothersMembersModal)
const mapStateToProps = (state) => {
    return {
        modalIsOpen: state.getIn(['ModalData', 'modalIsOpen', 'brothers_members_modal']),
        modalName: state.getIn(['ModalData', 'modalName']),
        modalMsg: state.getIn(['ModalData', 'modalMsg']),
    }
}
const mapDispatchToPorps = (dispatch) => ({
    openModal: (payload) => (
        dispatch(openModal(payload))
    ),
    chageModal: (payload) => (
        dispatch(chageModal(payload))
    ),
    closeModal: (payload) => (
        dispatch(closeModal(payload))
    ),
    editApplicationForAdmission: () => (
        dispatch(editApplicationForAdmission(dispatch))
    ),
    updateApplicationForAdmission: (payload) => (
        dispatch(updateApplicationForAdmission(dispatch, payload))
    ),
})

export default connect(mapStateToProps, mapDispatchToPorps)(BrothersMembersModal)


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/BrothsMembersModal.jsx